export default __webpack_public_path__ + "static/media/confirmacion.1c33034e.png";